import Error from '../model/Error';
import Offering from '../dto/offering/Offering';
import {i18n} from '../plugin/vue-i18n';

export default class OfferingValidator {

    static validateCourseOffering(offering) {
        return this.validate(offering);
    }

    static validateExamOffering(offering) {
        let error = this.validate(offering);

        if (!offering.clubExams || offering.clubExams.length === 0) {
            error.add('clubExams', i18n.t('offering.error.clubExam'));
        }

        return error;
    }

    static validateGenericOffering(offering) {
        let error = this.validate(offering);

        if (!offering.offeringCategory.id) {
            error.add('offeringCategoryId', i18n.t('offering.error.offeringCategory'));
        }

        return error;
    }


    static validateTrainingOffering(offering) {
        return this.validate(offering);
    }

    static validate(offering) {
        let error = new Error;

        if (!(offering instanceof Offering)) {
            error.add('offeringType','invalid argument');
            return error;
        }

        if (!offering.title) {
            error.add('title', i18n.t('offering.error.title'));
        }
        if (offering.isPublished()) {
            if (offering.appointmentSeriesList.length === 0) {
                error.add('appointmentSeriesList', i18n.t('offering.error.appointmentNeeded'));
            }

            if (!offering.bookableForMen && !offering.bookableForWomen) {
                error.add('bookableFor', i18n.t('offering.error.mustBeBookableForManOrWomen'));
            }

            if (!offering.bookableForActiveMembers && !offering.bookableForPassiveMembers && !offering.bookableForGuestMembers) {
                error.add('bookableFor', i18n.t('offering.error.mustBeBookableForMembers'));
            }

            if (offering.fields.length === 0) {
                error.add('selectedLocation', i18n.t('offering.error.needsALocation'));
                error.add('selectedArea', i18n.t('offering.error.needsALocation'));
                error.add('selectedFields', i18n.t('offering.error.needsALocation'));
            }
        }

        if (offering.bookingStartPerAppointmentAmount && !offering.bookingStartPerAppointmentType) {
            error.add('offeringBookingStartPerAppointmentType', i18n.t('offering.error.bookingPerAppointmentAmountOrTypeMissing'));
        }
        if (offering.bookingStartPerAppointmentType && !offering.bookingStartPerAppointmentAmount) {
            error.add('offering.bookingStartPerAppointmentAmount', i18n.t('offering.error.bookingPerAppointmentAmountOrTypeMissing'));
        }
        if (offering.bookingEndPerAppointmentAmount && !offering.bookingEndPerAppointmentType) {
            error.add('offeringBookingEndPerAppointmentType', i18n.t('offering.error.bookingPerAppointmentAmountOrTypeMissing'));
        }
        if (offering.bookingEndPerAppointmentType && !offering.bookingEndPerAppointmentAmount) {
            error.add('offering.bookingEndPerAppointmentAmount', i18n.t('offering.error.bookingPerAppointmentAmountOrTypeMissing'));
        }
        if (offering.cancellableUntilAmount && !offering.cancellableUntilType) {
            error.add('cancellableUntilType', i18n.t('offering.error.bookingPerAppointmentAmountOrTypeMissing'));
        }
        if (!offering.cancellableUntilAmount && offering.cancellableUntilType) {
            error.add('cancellableUntilAmount', i18n.t('offering.error.bookingPerAppointmentAmountOrTypeMissing'));
        }

        if (offering.useWaitList) {
            if (!offering.maxParticipants) {
                error.add('maxParticipants', i18n.t('offering.error.needsMaxParticipantsToUseWaitList'));
            }
            if (!offering.order) {
                error.add('waitListOrder', i18n.t('offering.error.waitListOrderMustBeSet'));
            }
            if (!offering.reservationTimeInMinutes) {
                error.add('reservationTimeInMinutes', i18n.t('offering.error.reservationTimeInMinutesMustBeSet'));
            }
        }

        const participantError = offering.checkParticipants();
        if (participantError !== null) {
            error.add('maxParticipants', i18n.t(participantError));
        }

        return error;
    }
}
